<template>
  <div v-if="!$store.getters.getCharts.length && !$store.getters.translationsLoaded" class="dashboard-container">
    <v-container fill-height fluid grid-list-lg text-xs-center px-3 py-2 class="sf-analytics">

      <!-- Dashboard loader -->
      <v-layout row>
        <v-flex xs12>
          <base-loader></base-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div v-else class="dashboard-container no-padding" >
    <v-container fill-height fluid grid-list-lg text-xs-center px-3 py-2 class="sf-analytics no-padding">
      <!-- sales funnel chart -->
      <v-layout row wrap class="no-padding">
        <v-flex xs12 class="no-padding">
          <component
            :is="$route.params.id"
            :chart-key="$route.params.key"
            :widget-key="$route.params.key"
            @open-dialog="openDialog($event)">
          </component>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- chart dialog window -->
    <v-dialog max-width v-model="dialog" @input="closeDialog()">
      <v-card>
        <v-card-title class="subheading">
          {{ dialogTitle }}
          <v-spacer></v-spacer>
          <v-btn icon small class="ma-0" @click="closeDialog()">
            <v-icon>fullscreen_exit</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="chart-wrapper">
            <component
              :is="dialogComponent"
              v-bind="dialogProperties"
              :from-dialog="true">
            </component>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/*
* i.e http://localhost:8080/#/widget/chart-funnel/SalesFunnel_funnelChart/1dwh9dig1zfp4acnt6do9j8uab
* */
import { eventBus } from '@/eventBus'
import auth from '@/api/auth'
import { mapGetters, mapMutations } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
import { am4themesEfdTheme } from '@/themes/index'
import BaseLoader from '@/components/loaders/BaseLoader'
import ChartFunnel from '@/components/charts/ChartFunnel'
import ChartBar from '@/components/charts/ChartBar'
import ChartBarRender from '@/components/charts/ChartBarRender'
import ChartPie from '@/components/charts/ChartPie'
import ChartPieRender from '@/components/charts/ChartPieRender'
import ChartLine from '@/components/charts/ChartLine'
import ChartLineRender from '@/components/charts/ChartLineRender'
import ChartLineDate from '@/components/charts/ChartLineDate'
import ChartLineDateRender from '@/components/charts/ChartLineDateRender'
import WidgetKpi from '@/components/charts/WidgetKpi'
am4core.options.queue = true
// am4core.useTheme(am4themesAnimated)
am4core.useTheme(am4themesEfdTheme)
export default {
  name: 'widget',
  components: {
    BaseLoader,
    ChartFunnel,
    ChartBar,
    ChartPie,
    ChartLine,
    ChartBarRender,
    ChartPieRender,
    ChartLineRender,
    ChartLineDate,
    ChartLineDateRender,
    WidgetKpi
  },
  data () {
    return {
      qp: {},
      charts: [],
      pdfExport: false,
      // dialog data
      dialog: false,
      dialogComponent: '',
      dialogTitle: '',
      dialogProperties: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedFiltersGen', 'getCharts', 'getChartByKey'
    ])
  },
  created: function () {
    this.qp = this.$route.query
    let settings = {
      key: this.$route.params.key,
      title: this.qp.name || 'BI',
      loaded: false,
      export: false,
      chartSettings: {
        orientation: 'vertical',
        legend: false,
        legendPosition: 'bottom'
      },
      data: {},
      pagination: {
        descending: false,
        sortBy: null
      }
    }
    if (this.qp && this.qp.pivotBy) {
      settings.chartSettings.pivotBy = this.qp.pivotBy.split(',')
    }
    if (typeof this.qp.legend === 'string' && this.qp.legend === 'true') {
      settings.chartSettings.legend = true
    } else {
      settings.chartSettings.legend = false
    }

    this.charts.push(settings)
    this.setCharts(this.charts)
  },
  mounted () {
    this.setGeneric(true)
    this.setFilters(this.$route.query)
    this.fetchDashboardData()
  },
  beforeCreate () {
    this.$store.commit('SET_AUTH_TOKEN', this.$route.params.token)
    auth.setAuthToken(this.$route.params.token)
    // TODO: refactor to be only on one component (App.vue)
    if (this.$route.query && this.$route.query.lang) {
      this.$log.info('Route query Language:', this.$route.query.lang)
      this.$store.commit('SET_LANGUAGE', this.$route.query.lang)
      this.$store.dispatch('fetchTranslations')
    } else {
      this.$store.commit('SET_LANGUAGE', 'en')
      this.$store.dispatch('fetchTranslations')
    }
  },
  beforeDestroy () {
    // empty charts from store
    this.setCharts([])
  },
  methods: {
    ...mapMutations({
      setCharts: 'SET_CHARTS',
      setFilters: 'GEN_SET_FILTERS_FROM_QUERY',
      setGeneric: 'GEN_SET_GENERIC'
    }),
    fetchDashboardData () {
      // emit event for fetching data from components
      eventBus.$emit('update-dashboard')
    },
    openDialog (dialogData) {
      this.$log.info('dialogData', dialogData)
      // assign received data from clicked component to Dialog component
      this.dialogComponent = dialogData.chartType
      this.dialogProperties = {}
      this.dialogProperties = { chartKey: dialogData.objectKey }
      this.dialogTitle = this.getChartByKey(dialogData.objectKey).title
      this.dialog = true
    },
    closeDialog () {
      // clear data for component
      this.dialogComponent = ''
      this.dialogProperties = {}
      this.dialogTitle = ''
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .dashboard-container {
    height: 100%;
  }
  .sf-analytics {
  }
  /*cleanup*/
  .no-padding {
    padding: 0!important;
  }
  @media only screen and (max-device-width: 700px) {
    .sf-analytics {
    }
  }
</style>
